module.exports = __webpack_public_path__ + "img/LOGOPIE_COINGASCO.a56a005a.png";